import { graphql } from "@cappelendamm/crystallize-types/pim/gql";
export const createApp = async ({ input }, { client }) => {
    return await client.pim.request(graphql(`
      mutation CreateApp($input: CreateAppInput!) {
        app {
          create(input: $input) {
            identifier
          }
        }
      }
    `), { input });
};
